
  import { Vue, Component, Prop } from "vue-property-decorator";
  import VuePlyr from "vue-plyr";
  @Component({
    components: {
      VuePlyr,
    },
  })
  export default class VideoPlayer extends Vue {
    @Prop({ type: String, required: true }) demoReel!: string;
  }
